import React from 'react'
import Preloader from '../../Global/Preloader';
import Headerone from '../Mainhomeone/Headerone';
import Bannerone from '../Mainhomeone/Bannerone';

import Servicesone from '../Mainhomeone/Servicesone';
import Featuresone from '../Mainhomeone/Featuresone';
import Whychooseone from '../Mainhomeone/Whychooseone';
import Partnerone from '../Mainhomeone/Partnerone';
import Processone from '../Mainhomeone/Processone';
import Casestudiesone from '../Mainhomeone/Casestudiesone';
import Teamone from '../Mainhomeone/Teamone';
import Testimonialone from '../Mainhomeone/Testimonialone';
import Blogone from '../Mainhomeone/Blogone';
import Ctaone from '../../Global/Ctaone';
import Footer from '../../Global/Footer';
import BackToTop from '../../Global/BackToTop';
import Headertwo from '../../Global/Headertwo';
import Featuresthree from '../Mainhometwo/Featuresthree';
import Whychoosetwo from '../Mainhometwo/Whychoosetwo';
import Abouttwo from '../Mainhomethree/Abouttwo';
import Blogthree from '../Mainhomethree/Blogthree';

const Main = () => {
    return (
        <>
       
        <Headertwo/>
        <Bannerone/>
        <Processone/>
        <Servicesone/>
        <Featuresthree />
        <Whychoosetwo/>
        <Abouttwo/>
        <Teamone/>
        <Testimonialone/>
        <Blogthree/>
        {/* <Featuresone/>
        <Whychooseone/>
        <Partnerone/>
        
        <Casestudiesone/>
      
        
        <Blogone/>
        <Ctaone/> */}
        <Footer/>
        <BackToTop />
        </>
    )
}
export default Main;